<template>
  <v-navigation-drawer v-model="this.$store.state.drawer" app>
    <v-list dense>
      <v-list-item to="/" link>
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home (New Invoice)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="item in menus"
        :key="item.title_en"
        :to="item.endpoint"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title_en }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { __HTTP, FormHeader } from "@/utils/utils";
export default {
  props: {
    source: String
  },
  methods: {
    getDrawer() {
      __HTTP(
        "?do=getdrawer",
        JSON.stringify({ id: this.$store.state.loggedUser.id }),
        FormHeader,
        res => {
          //console.log("MENU", res);
          this.menus = res;
        }
      );
    }
  },
  created() {
    this.getDrawer();
  },
  data() {
    return {
      menus: []
    };
  }
};
</script>
